import React from "react";
import "react-tabs/style/react-tabs.css";
import { Button } from "react-bootstrap";
import { Badge } from "react-bootstrap";
import { Card } from "react-bootstrap";
import { Breadcrumb } from "react-bootstrap";
import { withRouter } from 'react-router-dom';
import MUIDataTable from "mui-datatables";
import { Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { CardBody } from "reactstrap";
import EditIcon from '@material-ui/icons/Create';
import { IconButton } from '@material-ui/core';
import { Tooltip } from '@material-ui/core';
import SimpleReactValidator from 'simple-react-validator';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import dateFormat from 'dateformat';
import { connect } from "react-redux";
import 'moment/locale/fr.js' // or 'rc-datepicker/node_modules/moment/locale/fr.js' if you don't have it in your node_modules folder
import { DatePickerInput } from 'rc-datepicker';
import 'rc-datepicker/lib/style.css';
import moment from "moment";

class PriceMaster extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userData: [""],
      adminPass: "", statusEdit: [], statusUpdate: false, remarks: "", status: "",
      fromDate: "", toDate: "", fromDate1: "", toDate1: "", pricePerKL: "", selectDate: "", selectDate1: "", contractPriceToDate: "", contractPriceFromDate: ""
    };
    this.submitHandler = this.submitHandler.bind(this);
    this.pdValidator = new SimpleReactValidator({ autoForceUpdate: this, className: 'text-danger' });
  }

  submitHandler = () => {
    this.props.history.path("/user/user-create")
  }


  nextPath(path) {
    this.props.history.push({ pathname: path });
  }

  componentDidMount() {
    const url = process.env.REACT_APP_NODE_ENV + "/api/master/findAllMasterPrice";
    fetch(url,{
      method:'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
      }
    }).then(
      response => {
        return response.json();
      }
    ).then(data => {
      this.setState({ userData: data })
    })
  }

  editStatusHandler = () => {
    const doesToggle = this.state.editStatus;
    this.setState({ editStatus: !doesToggle });
  };

  save = () => {
    if (this.pdValidator.allValid()) {
      this.setState({ editStatus: false })
      let postOrderData = "";
      if (this.state.statusUpdate) {

        postOrderData = {
          fromDate: dateFormat(this.state.contractPriceFromDate, 'yyyy-mm-dd'), toDate: dateFormat(this.state.contractPriceToDate, 'yyyy-mm-dd'), pricePerKL: this.state.pricePerKL
        };
        console.log(postOrderData)
        fetch(process.env.REACT_APP_NODE_ENV + '/api/master/createMasterPrice', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': process.env.REACT_APP_API_AUTH_TYPE + btoa(process.env.REACT_APP_API_AUTH_USERNAME + ":" + process.env.REACT_APP_API_AUTH_PASSWORD),
          },
          body: JSON.stringify(postOrderData)
        }).then((res) => res.json())
          .then((data) => {
            console.log(data)
            this.componentDidMount()
          })
          .catch((err) => console.log(err))
      }
      else {
        this.componentDidMount();
      }
    }
    else {
      this.pdValidator.showMessages();
      this.forceUpdate();
    }
  }

  popUpCancel = () => {
    this.setState({ editStatus: false, statusUpdate: false });
  }

  handleUserFormFields = event => {
    this.pdValidator.showMessageFor(event.target.name)
    switch (event.target.id) {
      case "pdFromDate":
        this.setState({ fromDate: event.target.value, statusUpdate: true });
        break;
      case "pdToDate":
        this.setState({ toDate: event.target.value, statusUpdate: true });
        break;
      case "pdPricePerKL":
        this.setState({ pricePerKL: event.target.value, statusUpdate: true });
        break;
      default:
        break;
    }
  };

  handleChange2 = date => {
    this.setState({ contractPriceFromDate: date, statusUpdate: true });
  };

  handleChange3 = date => {
    this.setState({ contractPriceToDate: date, statusUpdate: true });
  };

  render() {

    let statusEdit = (
      <div className="kt-wizard-v1__form">
        <div className="row">
          <div className="col-lg-4">
            <label><b>From</b></label>
            <DatePickerInput locale='en' className='my-custom-datepicker-component'
              displayFormat="DD-MM-YYYY"
			  readOnly={true}
              value={this.state.contractPriceFromDate}
              selected={this.state.contractPriceFromDate ? moment(this.state.contractPriceFromDate) : null}
              onChange={this.handleChange2} />
            {/* {
            this.state.fcDueByRequired &&
            <span className="form-text text-muted">Please enter your FC Due By.</span>
          } */}
          </div>
          <div className="col-lg-3">
          </div>
          <div className="col-lg-4">
            <label><b>To</b></label>
            <DatePickerInput locale='en' className='my-custom-datepicker-component'
              displayFormat="DD-MM-YYYY"
			  readOnly={true}
              value={this.state.contractPriceToDate}
              selected={this.state.contractPriceToDate ? moment(this.state.contractPriceToDate) : null}
              onChange={this.handleChange3} />
            {/* {
            this.state.fcDueByRequired &&
            <span className="form-text text-muted">Please enter your FC Due By.</span>
          } */}
          </div>
        </div>
        <br /><br />
        <div className="row">
          <div className="col-lg-4">
          </div>
          <div className="col-lg-4">
            <div className="form-group">
              <label><b>Price per KL</b></label>
              <input type="text" className="form-control" id="pdPricePerKL" name='Price per KL' placeholder="Price per KL" value={this.state.pricePerKL} onChange={this.handleUserFormFields} style={{ fontWeight: 'bold' }} />
              {
                this.pdValidator.message('Price per KL', this.state.pricePerKL, 'required|integer')
              }
            </div></div>
        </div>
      </div>)

    let dataArray = [];
    this.state.userData.map((data) => {
      let mdData = {
        key: data.id,
        id: data.id, fromDate: dateFormat(data.fromDate, 'dd-mm-yyyy'), toDate: dateFormat(data.toDate, 'dd-mm-yyyy'), pricePerKL: data.pricePerKL
      };
      dataArray.push(mdData);
    });


    const columns = [
      {
        name: "fromDate",
        label: "From",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "toDate",
        label: "To",
        options: {
          filter: true,
          sort: true,
        }
      },
      {
        name: "pricePerKL",
        label: "Price Per KL",
        options: {
          filter: true,
          sort: true,
        }
      }
      // {
      //   name: "actions",
      //   label: "Actions",
      //   options: {
      //     filter: false,
      //     sort: false,
      //     customBodyRender: (value, tableMeta, updateValue) => {
      //       return (
      //         <><Tooltip title="Edit Status"><IconButton>
      //         <EditIcon onClick={() => this.editStatusHandler(value)} /></IconButton></Tooltip> </>
      //       );
      //     }
      //   }
      // }
    ];


    const options = {
      filterType: "textField",
      fixedHeader: true,
      sort: true,
      search: true,
      selectableRows: false,
      responsive: "scroll",
      rowsPerPage: 15,
      rowHove: true,
      selectableRowsHeader: true,
      expandableRows: false,
      expandableRowsOnClick: false
    };

    let PriceMasterTable = (<Card>
      <Card.Body>
        <div>
          <Button className="float-right"
            variant="outline-success"
            style={{ marginTop: "10px", width: "150px", marginRight: "25px" }}
            onClick={() => this.editStatusHandler()}>
            Add Price
 </Button></div>
        <MUIDataTable
          data={dataArray}
          columns={columns}
          options={options} />
      </Card.Body>
    </Card>);

    let editStatuss = null;
    if (this.state.editStatus) {
      editStatuss = (
        <Modal
          isOpen={true}
          style={{ width: "1200px", display: "block" }}
        >
          <Card style={{ width: "50rem" }}>
            <CardBody>
              <ModalHeader>Add Price</ModalHeader>
              <ModalBody>
                {statusEdit}
              </ModalBody>
              <ModalFooter>
                <Button variant="outline-primary" onClick={() => this.save()}>
                  Save
            </Button>&nbsp;&nbsp;&nbsp;
                <Button variant="outline-danger" onClick={() => this.popUpCancel()}> Cancel </Button>
              </ModalFooter>
            </CardBody>
          </Card>
        </Modal>
      );
    }

    return (
      <>
        <Breadcrumb>
          <Breadcrumb.Item active>Price Master</Breadcrumb.Item>
        </Breadcrumb>
        {editStatuss}

        <div>
          {PriceMasterTable}
        </div>
      </>
    );
  }
}

export default withRouter(PriceMaster);
